import React, { useRef, useEffect } from 'react';
import { badge, sliderImg1, sliderImg2, sliderImg3, sliderImg4, sliderImg5, sliderImg6, sliderImg7, sliderImg8 } from "../../../assets/img/index";

const cardData = [
  {
    id: 1,
    image: sliderImg1,
    name: 'Project 1',
    roundName: 'Round 1',
    raised: 10000,
    maxAmount: 20000,
  },
  {
    id: 2,
    image: sliderImg2,
    name: 'Project 2',
    roundName: 'Round 2',
    raised: 8500,
    maxAmount: 15000,
  },
  {
    id: 3,
    image: sliderImg3,
    name: 'Project 3',
    roundName: 'Round 3',
    raised: 7200,
    maxAmount: 10000,
  },
  {
    id: 4,
    image: sliderImg4,
    name: 'Project 4',
    roundName: 'Round 4',
    raised: 12300,
    maxAmount: 15000,
  },
  {
    id: 5,
    image: sliderImg5,
    name: 'Project 5',
    roundName: 'Round 5',
    raised: 15000,
    maxAmount: 20000,
  },
  {
    id: 6,
    image: sliderImg6,
    name: 'Project 6',
    roundName: 'Round 6',
    raised: 6500,
    maxAmount: 10000,
  },
];

const CardScroller = () => {
  const scrollerRef = useRef(null);

  const scrollLeft = () => {
    if (scrollerRef.current) {
      scrollerRef.current.scrollBy({ left: -350, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    if (scrollerRef.current) {
      scrollerRef.current.scrollBy({ left: 350, behavior: 'smooth' });
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (scrollerRef.current) {
        scrollerRef.current.scrollBy({ left: 350, behavior: 'smooth' });
      }
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{ position: 'relative', width: '100%', padding: '20px' }}>
      <button
        onClick={scrollLeft}
        style={{
          position: 'absolute',
          top: '50%',
          left: '0',
          transform: 'translateY(-50%)',
          backgroundColor: '#001352',
          color: 'white',
          border: 'none',
          borderRadius: '50%',
          width: '40px',
          height: '40px',
          cursor: 'pointer',
          zIndex: 10,
        }}
      >
        ‹
      </button>

      <div
        ref={scrollerRef}
        style={{
          display: 'flex',
          overflowX: 'hidden',
          scrollBehavior: 'smooth',
          padding: '20px',
          gap: '30px',
          borderRadius: '10px',
          width: '100%',
          scrollSnapType: 'x mandatory',
        }}
      >
        {cardData.map((card) => (
          <div
            key={card.id}
            style={{
              backgroundColor: 'white',
              borderRadius: '10px',
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
              minWidth: '300px',
              flex: '0 0 auto',
              padding: '0', // Remove padding to let image cover the upper part
              scrollSnapAlign: 'start',
              position: 'relative',
            }}
          >
            <img
              src={card.image}
              alt={card.name}
              style={{
                width: '100%',
                height: '200px', // Adjusted for larger height
                objectFit: 'cover',
                borderRadius: '10px 10px 0 0',
              }}
            />
            <div style={{ padding: '15px' }}>
              <h3 style={{ fontSize: '1.3rem', marginBottom: '10px', textAlign: 'center' }}>
                {card.roundName}: {card.name}
              </h3>

              <div
                style={{
                  width: '100%',
                  backgroundColor: '#e0e0e0',
                  borderRadius: '10px',
                  height: '8px',
                  marginBottom: '10px',
                  position: 'relative',
                }}
                title={`Raised: $${card.raised.toLocaleString()}`}
              >
                <div
                  style={{
                    width: `${(card.raised / card.maxAmount) * 100}%`,
                    backgroundColor: '#28a745',
                    height: '100%',
                    borderRadius: '10px',
                    transition: 'width 0.3s ease-in-out',
                  }}
                />
              </div>

              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <p style={{ fontSize: '0.9rem', color: '#6c757d' }}>
                  Goal: ${card.maxAmount.toLocaleString()}
                </p>
                <button
                  style={{
                    // padding: '10px 20px',
                    backgroundColor: '#001352',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                  }}
                >
                  View 
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      <button
        onClick={scrollRight}
        style={{
          position: 'absolute',
          top: '50%',
          right: '0',
          transform: 'translateY(-50%)',
          backgroundColor: '#001352',
          color: 'white',
          border: 'none',
          borderRadius: '50%',
          width: '40px',
          height: '40px',
          cursor: 'pointer',
          zIndex: 10,
        }}
      >
        ›
      </button>
    </div>
  );
};

export default CardScroller;
